import {Outlet} from 'react-router-dom';

const PublicLayout = () => (
    <main className="font-sans bg-bg text-ink min-h-screen">
        <Outlet/>
    </main>
);

export default PublicLayout;
